import React from 'react';
import { EmptyBlocks } from '@/components/icon/icons';
import ErrorNoteStyled from './ErrorNote.styled';

interface ErrorNoteProps {
  title: string;
  text: string;
}

const ErrorNote = ({ title, text }: ErrorNoteProps) => {
  return (
    <ErrorNoteStyled>
      <EmptyBlocks />
      <h1 className="error-note__title">{title}</h1>
      <p className="error-note__text">{text}</p>
    </ErrorNoteStyled>
  );
};

export default ErrorNote;
